var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 2c-5.5143 0-9.9999 4.4861-9.9999 10s4.4857 10 9.9999 10c5.5144 0 10-4.4861 10-10s-4.4857-10-10-10zm3.9754 10.35-5.8333 3.75c-0.06836 0.0443-0.14731 0.06635-0.22543 0.06635-0.068361 0-0.13754-0.01707-0.19938-0.05089-0.13429-0.07326-0.2173-0.21318-0.2173-0.36586v-7.4999c0-0.15258 0.083012-0.29258 0.2173-0.36581 0.13183-0.072424 0.29703-0.067972 0.42481 0.015462l5.8333 3.75c0.11886 0.07649 0.19124 0.20876 0.19124 0.35036 0 0.14161-0.07239 0.27383-0.19124 0.35036z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.982 19.646h-0.91472v-3.4472c-0.33419 0.31247-0.72802 0.54358-1.1816 0.69333v-0.83001c0.23868-0.07812 0.49799-0.22571 0.77793-0.44278 0.27994-0.21912 0.47206-0.47411 0.57621-0.76497h0.74218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.0a44bc242c9f94ce31380daeafcd36b6.svg";
export { ForwardRef as ReactComponent };